import Vue from 'vue'

const saveLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

const getLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key))
}

const rawFieldsOrder = [{
  name: 'order',
  label: 'Orden',
  divider: false,
  order: 0,
  show: true
},
{
  name: 'status',
  label: 'Estado',
  divider: false,
  order: 1,
  show: true
},
{
  name: 'methodPay',
  label: 'Método de pago',
  divider: false,
  order: 2,
  show: true
},
{
  name: 'conveyor',
  label: 'Transportadora',
  divider: true,
  order: 3,
  show: true
},
{
  name: 'total',
  label: 'Total',
  divider: false,
  order: 4,
  show: true
},
{
  name: 'name',
  label: 'Nombre',
  divider: false,
  order: 5,
  show: true
},
{
  name: 'location',
  label: 'Ubicación',
  divider: false,
  order: 6,
  show: true
},
{
  name: 'phones',
  label: 'Teléfono',
  divider: false,
  order: 7,
  show: true
},
{
  name: 'createdAt',
  label: 'Fecha',
  divider: false,
  order: 8,
  show: true
},
{
  name: 'remit',
  label: 'Remite',
  divider: false,
  order: 9,
  show: true
},
{
  name: 'percent',
  label: 'Porcentaje',
  divider: false,
  order: 10,
  show: false
},
{
  name: 'reconcile',
  label: 'Conciliado',
  divider: false,
  order: 11,
  show: false
}]

export default {
  state: {
    menus: [],
    settings: {
      show: false
    },
    fieldsOrder: JSON.parse(JSON.stringify(rawFieldsOrder)),
    menuPrincipalHidden: false
  },
  mutations: {
    setMenuPrincipalHidden (state, value) {
      state.menuPrincipalHidden = value
    },
    hideAllMenus (state) {
      state.menus.forEach((_, index) => {
        console.log('hideAllMenus', index)
        Vue.set(state.menus, index, false)
      })
    },
    hideMenu (state, index) {
      console.log('hideMenu', index)
      Vue.set(state.menus, index, false)
    },
    showMenu (state, index) {
      Vue.set(state.menus, index, true)
    },
    setFieldsOrder (state, fields) {
      fields.forEach((field, index) => {
        field.order = index
      })
      state.fieldsOrder = fields
      saveLocalStorage('fieldsOrder', fields)
    },
    loadFieldsOrder (state) {
      state.fieldsOrder = getLocalStorage('fieldsOrder') || state.fieldsOrder
    },
    showSettings (state) {
      state.settings.show = true
    },
    hideSettings (state) {
      state.settings.show = false
    },
    resetFieldsOrder (state) {
      state.fieldsOrder = JSON.parse(JSON.stringify(rawFieldsOrder))
    }
  },
  actions: {
    setMenu ({ state }) {
      const index = state.menus.push(true) - 1
      return index
    },
    initializeMenuListener ({ commit }) {
      document.addEventListener('click', () => {
        commit('hideAllMenus')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/interface.js